<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000" class="no-display">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-row fluid justify="center" v-if="ut == 'Employee'" class="no-display">
      <v-radio-group v-model="print_type" row>
        <v-radio label="Print Single" value="Single"></v-radio>
        <v-radio label="Print Bulk" value="Bulk" @change="putnull()"></v-radio>
      </v-radio-group>
    </v-row>

    <template v-if="print_type == 'Single'">
      <v-row dense justify="center" class="no-display">
        <v-col sm="3" md="3">
          <v-icon color="error" class="no-display">*</v-icon>
          <v-autocomplete class="no-display" :items="academic_year_list" item-value="ay_id" item-text="academicyear"
            v-model="ay" label="Select AY" dense rounded outlined color="#0F2027"></v-autocomplete>
        </v-col>
        <v-col sm="3" md="3">
          <v-icon color="error" class="no-display">*</v-icon>
          <v-autocomplete class="no-display" :items="stud_list" item-value="lid" v-model="stud_data" item-text="name"
            label="Student" dense rounded outlined @click="putnull()" :loading="comp_load"
            placeholder="Search by PRN No or name" color="#0F2027"></v-autocomplete>
        </v-col>
        <v-col sm="3" md="3">
          <v-icon color="error" class="no-display">*</v-icon>
          <v-autocomplete class="no-display" :items="sem_list" item-value="id" item-text="sem" v-model="sem"
            label="Semester" dense rounded outlined color="#0F2027"></v-autocomplete>
        </v-col>
        <v-col sm="3" md="3">
          <v-icon color="error" class="no-display">*</v-icon>
          <v-autocomplete class="no-display" :items="assessment_type_list" item-value="id" item-text="ass_type_name"
            v-model="assessmenttype" label="Assessment Type" dense rounded outlined color="#0F2027"></v-autocomplete>
        </v-col>
        <v-btn v-if="ay && stud_data && sem && assessmenttype" v-model="gen_ticket" @click="getHallticket"
          color="success" class="no-display">Generate Hall Ticket</v-btn>
      </v-row>
    </template>

    <!-- ===================== BULK ===================== -->
    <template v-if="print_type == 'Bulk'">
      <v-row dense justify="center" class="no-display">
        <v-col sm="2" md="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete class="no-display" :items="academic_year_list" item-value="ay_id" item-text="academicyear"
            v-model="ay" label="Select Ay" dense rounded outlined color="#0F2027"></v-autocomplete>
        </v-col>
        <v-col sm="2" md="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete class="no-display" :items="std_list" item-value="id" item-text="standard" v-model="std"
            label="Search Standard" dense rounded outlined color="#0F2027"></v-autocomplete>
        </v-col>
        <v-col sm="2" md="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete class="no-display" :items="div_list" item-value="id" item-text="division" v-model="div"
            label="Search Division" dense rounded outlined color="#0F2027"></v-autocomplete>
        </v-col>
        <v-col sm="3" md="3">
          <v-icon color="error">*</v-icon>
          <v-autocomplete class="no-display" :items="sem_list" item-value="id" item-text="sem" v-model="semester"
            label="Semester" dense rounded outlined color="#0F2027"></v-autocomplete>
        </v-col>
        <v-col sm="3" md="3">
          <v-icon color="error">*</v-icon>
          <v-autocomplete class="no-display" :items="assessment_type_list" item-value="id" item-text="ass_type_name"
            v-model="assesstype" label="Assessment Type" dense rounded outlined color="#0F2027"></v-autocomplete>
        </v-col>
        <v-btn v-if="ay && std && div && semester && assesstype" color="success" @click="getBulkHallticket">Generate
          Bulk Hall Ticket</v-btn>
      </v-row>
    </template>

    <!-- ===================== PARENT / STUDENT ===================== -->
    <template v-if="ut == 'Parent' || ut == 'Student'">
      <v-row dense justify="center" class="no-display">
        <v-col sm="3" md="3">
          <v-icon color="error" class="no-display">*</v-icon>
          <v-autocomplete class="no-display" :items="academic_year_list" item-value="ay_id" item-text="academicyear"
            v-model="ay" label="Select AY" dense rounded outlined color="#0F2027"></v-autocomplete>
        </v-col>
        <v-col sm="3" md="3" v-if="ut != 'Student'">
          <v-icon color="error" class="no-display">*</v-icon>
          <v-autocomplete class="no-display" :items="child_list" item-value="id" v-model="child" item-text="learner"
            label="Child" dense rounded outlined @click="putnull()" :loading="comp_load"
            placeholder="Search by PRN No or name" color="#0F2027"></v-autocomplete>
        </v-col>
        <v-col sm="3" md="3">
          <v-icon color="error" class="no-display">*</v-icon>
          <v-autocomplete class="no-display" :items="sem_list" item-value="id" item-text="sem" v-model="sem"
            label="Semester" dense rounded outlined color="#0F2027"></v-autocomplete>
        </v-col>
        <v-col sm="3" md="3">
          <v-icon color="error" class="no-display">*</v-icon>
          <v-autocomplete class="no-display" :items="assessment_type_list" item-value="id" item-text="ass_type_name"
            v-model="assessmenttype" label="Assessment Type" dense rounded outlined color="#0F2027"></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="4" md="4" align="center">
          <v-btn v-if="ay && sem && assessmenttype" v-model="gen_ticket" @click="getHallticket" color="success"
            class="no-display">Generate Hall Ticket</v-btn>
        </v-col>
      </v-row>
    </template>

    <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()" v-if="gen_ticket">
      <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
    </v-btn>

    <div class="printdiv" v-if="gen_ticket">
      <v-row align="center" no-gutters class="ht-header">
        <v-col :cols="isMkd ? 2 : 3" :sm="isMkd ? 2 : 3" :md="isMkd ? 2 : 3" style="text-align: center;">
          <img class="logo" :src="org_basic_data.school_logo" alt="logo" width="115" height="115" />
        </v-col>
        <v-col :cols="isMkd ? 8 : 9" :sm="isMkd ? 8 : 9" :md="isMkd ? 8 : 9" class="text-center"
          style="text-align: center; overflow: visible; height: auto;">
          <h3 class="ht-title">{{ org_basic_data.trust_name }}</h3>
          <h3 class="ht-title ht-school org_name">{{ org_basic_data.school_name }}</h3>
          <h3 class="ht-title ht-school ht">Hall Ticket</h3>
        </v-col>
        <v-col v-if="isMkd && org_id != '4'" cols="2" sm="2" md="2" style="text-align: center;">
          <img class="logo" :src="org_basic_data.trust_logo" alt="logo" width="100" height="100" />
        </v-col>
      </v-row>

      <v-row class="ht-text ht-student">
        <v-col cols="12" sm="8" md="8">
          <div>
            <b>Student PRN :
              <span class="ht-line" :class="{ 'ht-noline': isMkd }">{{ hall_ticket_data[0].prn }}</span>
            </b>
          </div>
          <div>
            <b>Student's Name :
              <span class="ht-line" :class="{ 'ht-noline': isMkd }">{{ hall_ticket_data[0].stud_name }}</span>
            </b>
          </div>
          <div>
            <b>Mother's Name :
              <span class="ht-line" :class="{ 'ht-noline': isMkd }">{{ hall_ticket_data[0].mother_full_name }}</span>
            </b>
          </div>
          <div>
            <b>Father's Name :
              <span class="ht-line" :class="{ 'ht-noline': isMkd }">{{ hall_ticket_data[0].father_full_name }}</span>
            </b>
          </div>
          <div>
            <b>Date of Birth :
              <span class="ht-line" :class="{ 'ht-noline': isMkd }">{{ hall_ticket_data[0].stud_dob }}</span>
            </b>
          </div>
        </v-col>
        <v-col align="right" style="max-width: none;">
          <div class="ht-photo">
            <img v-if="isValidPhoto" :src="hall_ticket_data[0].profile_photo_path" alt="" />
            <span v-else>Photo</span>
          </div>
        </v-col>
      </v-row>

      <!-- Gender / stream / medium -->
      <v-row class="ht-text ht-meta">
        <v-col cols="12" sm="3" md="3"><b>Gender: {{ hall_ticket_data[0].gender }}</b></v-col>
        <v-col cols="12" sm="4" md="4"><b>Stream: {{ hall_ticket_data[0].stream }}</b></v-col>
        <v-col cols="12" sm="5" md="5"><b>Medium of Instruction: {{ hall_ticket_data[0].medium_of_instruction
            }}</b></v-col>
      </v-row>

      <!-- Class / division / roll / exam -->
      <v-row class="ht-text ht-meta">
        <v-col cols="12" sm="2" md="2"><b>Class: {{ hall_ticket_data[0].std }}</b></v-col>
        <v-col cols="12" sm="3" md="3"><b>Division: {{ hall_ticket_data[0].div }}</b></v-col>
        <v-col cols="12" sm="2" md="2"><b>Roll No.: {{ hall_ticket_data[0].rollno }}</b></v-col>
        <v-col cols="12" sm="5" md="5"><b>Examination: {{ hall_ticket_data[0].exam_name }}</b></v-col>
      </v-row>

      <!-- Subject table -->
      <div class="ht-text ht-subject-title"><b>Subject Details</b></div>
      <table class="timetable ht-text">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>DAY / DATE</th>
            <th>TIME</th>
            <th>SUBJECT</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in sortedExamPlanData" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.day }} <br class="ht-br" /> {{ item.date }}</td>
            <td>{{ item.from_time }} to <br class="ht-br" /> {{ item.to_time }}</td>
            <td>{{ item.subject }}</td>
          </tr>
        </tbody>
      </table>

      <!-- Instructions -->
      <div class="ht-text ht-instr-title"><b>Instructions to Student:</b></div>
      <ol class="instr">
        <li v-for="(instruction, index) in splitInstructions" :key="index">{{ instruction }}</li>
      </ol>

      <!-- Signatures -->

      <v-row class="ht-text ht-sign">
        <v-col cols="12" sm="4" md="4" align="center">
          <div class="sign-area">
            <img v-if="!isMkd && hall_ticket_data[0].student_sign && !hall_ticket_data[0].student_sign.includes('/null')"
              :src="hall_ticket_data[0].student_sign" class="signature-img" />
          </div>
          {{ isMkd ? 'Class Teacher Sign.' : 'Student Sign.' }}
        </v-col>

        <v-col cols="12" sm="4" md="4" align="center">
          <div class="sign-area">
            <img v-if="hall_ticket_data[0].exam_in_charge_url && !hall_ticket_data[0].exam_in_charge_url.endsWith('/null')"
              :src="hall_ticket_data[0].exam_in_charge_url" class="signature-img" />
          </div>
          Exam In-charge
        </v-col>
        <v-col cols="12" sm="4" md="4" align="center">
          <div class="sign-area">
            <img v-if="hall_ticket_data[0].principal_sign && !hall_ticket_data[0].principal_sign.endsWith('/null')"
              :src="hall_ticket_data[0].principal_sign" class="signature-img" />
          </div>
          Principal Sign &amp; Stamp
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import axios from "axios";
export default {
  data: () => ({
    comp_load: false,
    snackbar_msg: "",
    snackbar: false,
    color: "",
    stud_data: null,
    ay: "",
    stud_list: null,
    std_list: null,
    div_list: null,
    academic_year_list: [],
    std: null,
    div: null,
    print_type: null,
    gen_ticket: false,
    sem_list: [],
    assessment_type_list: [],
    sem: null,
    assessmenttype: null,
    org_basic_data: [],
    hall_ticket_data: [],
    instructions_list: [],
    assesstype: null,
    semester: null,
    examPlanData: [],
    ut: null,
    org_id: null,
    child_list: [],
    child: null,
    child_data: []
  }),
  computed: {
    splitInstructions() {
      if (!this.instructions_list || !this.instructions_list.length) return [];
      return String(this.instructions_list[0].value || "")
        .split(". ")
        .map((item) => item.trim())
        .filter((item) => item)
        // remove trailing dots so we never get "uniform only.."
        .map((item) => item.replace(/\.+$/, "") + ".");
    },
    sortedExamPlanData() {
      return this.examPlanData.slice().sort((a, b) => {
        const dateA = new Date(this.formatDate(a.date, a.from_time));
        const dateB = new Date(this.formatDate(b.date, b.from_time));
        return dateA - dateB;
      });
    },
    isMkd() {
      const name = (this.org_basic_data.school_name || "")
        .toUpperCase()
        .replace(/[\s.]/g, "");
      return name.startsWith("MKD");
    },
    isValidPhoto() {
      const path = this.hall_ticket_data[0].profile_photo_path;
      return path && !path.includes("null");
    }
  },
  methods: {
    formatDate(date, time) {
      const [day, month, year] = date.split("/");
      const monthMap = {
        Jan: "01", Feb: "02", Mar: "03", Apr: "04", May: "05", Jun: "06",
        Jul: "07", Aug: "08", Sep: "09", Oct: "10", Nov: "11", Dec: "12"
      };
      const formattedMonth = monthMap[month];
      const formattedTime = this.convertTo24HourFormat(time);
      return `${year}-${formattedMonth}-${day}T${formattedTime}:00`;
    },
    convertTo24HourFormat(time) {
      const [timePart, modifier] = time.split(" ");
      let [hours, minutes] = timePart.split(":");
      if (modifier === "PM" && hours !== "12") {
        hours = parseInt(hours, 10) + 12;
      } else if (modifier === "AM" && hours === "12") {
        hours = "00";
      }
      return `${hours}:${minutes}`;
    },
    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    putnull() {
      this.gen_ticket = false;
    },
    onload() {
      this.comp_load = true;
      axios
        .post("/Examination/getdataforhallticketStudent")
        .then((res) => {
          if (res.data.msg == "200") {
            this.stud_list = res.data.stud_list;
            this.std_list = res.data.std_list;
            this.div_list = res.data.div_list;
            this.academic_year_list = res.data.academic_year_list;
            this.assessment_type_list = res.data.assessment_type_list;
            this.sem_list = res.data.sem_list;
            this.ay = res.data.current_ay;
          } else {
            alert("Somthing went wrong!!!");
          }
        })
        .catch((error) => {
          alert("Somthing went wrong!!!");
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
    getHallticket() {
      this.gen_ticket = true;
      var data;
      if (this.ut == "Parent") {
        data = {
          stud_data: this.child,
          ay: this.ay,
          sem: this.sem,
          asstype: this.assessmenttype,
        };
      } else if (this.ut == "Student") {
        data = {
          stud_data: this.child_data[0].lid,
          ay: this.ay,
          sem: this.sem,
          asstype: this.assessmenttype,
        };
      } else {
        data = {
          stud_data: this.stud_data,
          ay: this.ay,
          sem: this.sem,
          asstype: this.assessmenttype,
        };
      }
      axios
        .post("Examination/gethallticketGenerateStudent", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.org_basic_data = res.data.org_basic_data;
            this.hall_ticket_data = res.data.hall_ticket_data;
            this.instructions_list = res.data.instructions_list;
            this.examPlanData = res.data.exam_plan_data;
          } else if (res.data.flag == "NO") {
            this.showSnackbar("red", res.data.snackbar);
            this.gen_ticket = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("red", "Something went wrong");
          this.gen_ticket = false;
        })
        .finally(() => { });
    },
    getBulkHallticket() {
      const data = {
        ay: this.ay,
        sem: this.semester,
        asstype: this.assesstype,
        std: this.std,
        div: this.div,
      };
      axios
        .post("Examination/bulkhallticketGenerateStudent", data)
        .then((res) => {
          if (res.data.msg == "200") {
            this.org_basic_data = res.data.org_basic_data;
            this.hall_ticket_data = res.data.hall_ticket_data;
            this.instructions_list = res.data.instructions_list;
            localStorage.setItem("org_basic_data", JSON.stringify(this.org_basic_data));
            localStorage.setItem("hall_ticket_data", JSON.stringify(this.hall_ticket_data));
            localStorage.setItem("instructions_list", JSON.stringify(this.instructions_list));
            let routeData = this.$router.resolve({
              name: "hallticket-bulk-print",
            });
            window.open(routeData.href, "_blank");
          } else {
            this.showSnackbar("red", "Something went wrong...");
          }
        })
        .catch((error) => {
          this.showSnackbar("red", "Something went wrong");
        })
        .finally(() => { });
    },
    getChild() {
      axios
        .post("Analytics/analyticsHome")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.child_list = res.data.learner_list;
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => { });
    },
    getChildId() {
      axios
        .post("commonAPI/getLearnerData")
        .then((res) => {
          if (res.data.status == "SUCCESS") {
            this.child_data = res.data.child_data;
          } else {
            if (this.ut == "Student") {
              this.showSnackbar("#b71c1c", res.data.status_reason);
            }
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => { });
    }
  },
  mounted() {
    this.onload();
    this.ut = localStorage.getItem("EPS-ut");
    this.org_id = localStorage.getItem("EPS-org-id");
    this.getChild();
    this.getChildId();
  },
};
</script>

<style>
.sign-area {
    height: 55px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    margin-bottom: 5px;
}

.signature-img {
    max-width: 120px;
    max-height: 50px;
    object-fit: contain;
}
.printdiv {
  margin-left: 20%;
  margin-right: 20%;
  background-color: white;
  padding: 20px;
  padding-bottom: 0px;
  font-family: "Times New Roman", Times, serif;
}

.printdiv .ht-title {
  margin: 0 0 8px 0;
  line-height: 1.3;
}

.printdiv .ht-school,
.printdiv .ht {
  color: #000087;
}

.printdiv .ht-text {
  font-size: 20px;
}

.printdiv .ht-meta .col {
  padding-top: 2px;
  padding-bottom: 2px;
}

.printdiv .ht-line {
  display: inline-block;
  width: 70%;
  border-bottom: 1px solid black;
  vertical-align: bottom;
}

.printdiv .ht-noline {
  border-bottom: none;
}

.printdiv .ht-photo {
  height: 140px;
  width: 120px;
  margin-right: 30px;
  border: 1px solid black;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.printdiv .ht-photo img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.printdiv .ht-subject-title {
  margin-top: 10px;
}

.printdiv .ht-instr-title {
  margin-top: 14px;
}

.printdiv .instr {
  list-style: none;
  padding: 0;
  margin: 0 0 0 11px;
  padding-top: 10px;
  line-height: 110%;
  font-size: 18px;
}

.printdiv .instr li {
  margin-bottom: 10px;
}

.printdiv .ht-sign {
  font-weight: bold;
  padding-top: 17px;
  padding-bottom: 10px;
}

.timetable {
  border-collapse: collapse;
  width: 100%;
}

.timetable td,
.timetable th {
  border: 1px solid black;
  padding: 4px;
  text-align: center;
}

.timetable td:first-child {
  width: 10%;
}

@media print {
  @page {
    size: A4 portrait;
    margin: 8mm;
  }

  html,
  body {
    height: auto !important;
    min-height: 0 !important;
    background: #fff !important;
  }

  .v-navigation-drawer,
  .v-app-bar,
  .v-toolbar,
  .v-footer,
  .v-snackbar,
  header,
  footer,
  nav,
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }

  .v-application,
  .v-application--wrap {
    min-height: 0 !important;
    height: auto !important;
    background: #fff !important;
  }

  .v-main,
  .v-content,
  .v-main__wrap,
  .v-content__wrap,
  .container,
  .container--fluid {
    padding: 0 !important;
    margin: 0 !important;
    max-width: 100% !important;
  }


  .printdiv {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    box-sizing: border-box !important;
    margin: 0 !important;
    padding: 0 2mm !important;
    width: 100% !important;
    max-width: 100% !important;
    max-height: 281mm;
    overflow: hidden;
    page-break-inside: avoid;
    break-inside: avoid;
    page-break-after: avoid;
    break-after: avoid;
  }

  .printdiv .row {
    margin: 0 !important;
  }

  .printdiv .col {
    padding-top: 4px !important;
    padding-bottom: 4px !important;
  }

  .printdiv .ht-text {
    font-size: 14px !important;
  }

  .printdiv .ht-title {
    font-size: 14px !important;
    margin-bottom: 8px !important;
  }

  .printdiv .logo {
    width: 100px !important;
    height: 100px !important;
    margin-left: 0 !important;
  }

  .printdiv .ht-header {
    margin-bottom: 10px !important;
  }

  .printdiv .ht-student>.col:first-child>div {
    margin-bottom: 4px;
  }

  .printdiv .ht-photo {
    height: 140px;
    width: 115px;
    margin-right: 10px;
  }

  .printdiv .ht-meta .col {
    padding-top: 5px !important;
    padding-bottom: 5px !important;
  }

  .printdiv .ht-subject-title {
    margin-top: 14px;
    margin-bottom: 4px;
  }

  .timetable td,
  .timetable th {
    padding: 6px 4px !important;
    font-size: 14px !important;
  }

  .timetable .ht-br {
    display: none;
  }

  .timetable tr {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .printdiv .ht-instr-title {
    margin-top: 12px;
  }

  .printdiv .instr {
    font-size: 14px !important;
    padding-top: 8px;
    line-height: 120%;
  }

  .printdiv .instr li {
    margin-bottom: 5px !important;
  }

  .printdiv .ht-sign {
    padding-top: 35px;
    padding-bottom: 0;
  }
}
</style>